import PropTypes from 'prop-types';

export const QualityApproval = {
  requestId: PropTypes.number,
  partId: PropTypes.number,
  partNumber: PropTypes.string,
  request: PropTypes.string,
  serialNumber: PropTypes.string,
  workTicket: PropTypes.string,
  categoryId: PropTypes.number,
  statusId: PropTypes.number,
  comments: PropTypes.string,
  createdBy: PropTypes.string,
  createdDate: PropTypes.string,
  statusChangedBy: PropTypes.string,
  statusChangedDate: PropTypes.string,
  isActive: PropTypes.bool,
  images: PropTypes.object,
  categoryName: PropTypes.string,
  statusName: PropTypes.string,
};
